import script from "./CommentsSectionMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentsSectionMain.vue?vue&type=script&setup=true&lang=ts"

import "./CommentsSectionMain.vue?vue&type=style&index=0&id=0265e883&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0265e883"]])

export default __exports__